import { Dispatch } from '@reduxjs/toolkit';
import React from 'react';
import { connect } from 'react-redux';
import { Notification } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { queryClient } from '../../../../../App';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { resetPriceManagerFilters } from '../../../../../components/NewFilterBox/data/utils';
import { selectorDeleteFilter, SET_IS_OPEN } from '../../../../../reducers/ipa/priceManager/modals/deleteFilter';
import { selectorSaveFilters } from '../../../../../reducers/ipa/priceManager/modals/saveFilters';
import { deleteSavedFilter } from '../../services_ts';
import { ExcluirFiltroModal } from '../ExcluirFiltroModal';

type DeleteFilterModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const DeleteFilterModalWrapper = ({ deleteFilter, saveFilters, closeModal, resetFilters }: DeleteFilterModalWrapperProps) => {
  const handleDeleteFilter = async (id: string) => {
    try {
      const response = await deleteSavedFilter(id ?? '');
      if (response.status !== 200) return;

      await queryClient.invalidateQueries(['ipa.filter.savedFilters']);

      Notification.success({ description: 'Filtro excluido com sucesso.' });

      resetFilters();
      closeModal();
    } catch (err) {
      AlertWithTimestamp({ message: err.response.data._embedded.errors[0].message });
    }
  };

  return <ExcluirFiltroModal show={deleteFilter.isOpen} onHide={closeModal} onConfirm={handleDeleteFilter} saveFilter={saveFilters} />;
};

const mapStateToProps = (state: RootState) => ({
  deleteFilter: selectorDeleteFilter(state),
  saveFilters: selectorSaveFilters(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
  resetFilters: () => resetPriceManagerFilters(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteFilterModalWrapper);
